/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type IntervaloData } from '../utils/types';
import { type Filtro, type Faturamento } from './types';
import { type Totalizador } from '../home/widgets/view/types';

export type TicketMedio = {
    dias: {
        dataFormatada: string,
        soma: number,
    }[],
    total: number,
};

const calcularTicketMedio = (params: Filtro): AxiosPromise<TicketMedio> => (
    xhr.get('/relatorios/pedidos/ticket-medio', { params })
);

const calcularFaturamento = (params: Filtro): AxiosPromise<Faturamento> => (
    xhr.get('/relatorios/faturamento', { params })
);

type VolumePedidos = {
    horas: Array<{
        horaFormatada: string,
        quantidade: number,
    }>,
    dias: Array<{
        dataFormatada: string,
        quantidade: number,
    }>,
    diaDaSemana: Array<{
        diaSemana: string,
        quantidade: number,
    }>
};

const calcularVolumePedidos = (params: Filtro): AxiosPromise<VolumePedidos> => (
    xhr.get('/relatorios/volume-pedidos', { params })
);

export type ProdutosMaisVendidos = {
    nome: string,
    quantidade: number,
    id: number,
    valor: number,
};

const calcularProdutosMaisVendidos = (
    params: IntervaloData,
): AxiosPromise<ProdutosMaisVendidos[]> => (
    xhr.get('/relatorios/produtos-mais-vendidos', { params })
);

const totalPorFormaPagamento = (params: Filtro): AxiosPromise<Totalizador[]> => (
    xhr.get('/relatorios/pedidos/total-por-tipo-forma-pagamento', { params })
);

const totalPorEntregador = (params: Filtro): AxiosPromise<Totalizador[]> => (
    xhr.get('/relatorios/pedidos/total-por-entregador', { params })
);

export type CadastroUsuariosPorMes = {
    ano: string,
    mes: string,
    cadastros: string,
};

const cadastrosUsuariosPorMes = (
    params: { nivel: string, origem?: 'balcao' | 'app' },
): AxiosPromise<CadastroUsuariosPorMes[]> => (
    xhr.get('/relatorios/cadastros-usuarios-por-mes', { params })
);

const relatorios = {
    calcularTicketMedio,
    calcularFaturamento,
    calcularVolumePedidos,
    calcularProdutosMaisVendidos,
    totalPorFormaPagamento,
    totalPorEntregador,
    cadastrosUsuariosPorMes,
};

export default relatorios;
